<template>
  <div>
    <v-row class="mt-7 mx-4" justify="center">
      <v-col cols="12" md="4" class="d-flex justify-center align-center">
        <app-pagination-h
          v-model="pagina"
          :total-pages="totalPages || 0"
          @change="cambiarPagina"
          class="principalPagination"
        ></app-pagination-h>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import AppPaginationH from "../views/mantenimientos/usuarios/historial/components/AppPagination.vue";
export default {
  name: "AppPagination",
  components: {
    AppPaginationH
  },
  props: {
    page: {
      type: Number,
      default: 1,
    },
    totalRegistros: {
      type: Number,
      default: 0,
    },
    perPage: {
      type: Number,
      default: 25,
    },
  },

  methods: {
    cambiarPagina(event) {
      this.$emit("input", event);
    },
    updatePerPage() {
      this.pagina = 1;
      this.$emit("change");
    },
  },
  computed: {
    pagina: {
      get() {
        return this.page;
      },
      set(value) {
        this.$emit("update:page", value);
      },
    },
    porPagina: {
      get() {
        return this.perPage;
      },
      set(value) {
        this.$emit("update:perPage", value);
      },
    },
    totalPages() {
      return Math.ceil(this.totalRegistros / this.perPage);
    },
  },
};
</script>

<style lang="scss" scoped>
.v-select {
  max-width: 55px !important;
}

.principalPagination >>> .pagination {
  display: block !important;
}

:deep(.v-select__selection--comma) {
  margin: 7px 4px 7px 0;
  min-height: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #313945 !important;
}

:deep(.theme--light.v-pagination .v-pagination__item--active) {
  color: #ffffff;
  background-color: #313945;
}
</style>
